module.exports = __webpack_public_path__ + "media/images/dropdown_indication_example-7583ed9df20458c779522c6e6162637d.png";